<template>
  <div class="header-container" :style="{background: whiteback}">
    <div class="header-logo"></div>

    <ul class="header-nav">
      <li>
        <router-link to="/home" active-class="active">首页</router-link>
      </li>
      <li @mouseenter="show=true" @mouseleave="show=flase">
        <router-link to="/company" active-class="active">公司介绍</router-link>
      </li>
<!--      <li @mouseenter="show1=true" @mouseleave="show1=flase">-->
<!--        <router-link to="/products" active-class="active">产品服务</router-link>-->
<!--      </li>-->
<!--      <li>-->
<!--        <router-link to="/cooperation" active-class="active">合作企业</router-link>-->
<!--      </li>-->
      <li>
        <router-link to="/join" active-class="active">加入我们</router-link>
      </li>
    </ul>

    <!-- 下拉菜单 -->
    <ul class="header-dropdown" :class="{isShow : show}" @mouseenter="show=true" @mouseleave="show=flase">
      <li>
        <router-link to="/company">公司简介</router-link>
      </li>
      <li>
        <router-link to="/company/development">发展历程</router-link>
      </li>
      <li>
        <router-link to="/company/culture">公司文化</router-link>
      </li>
      <li>
        <router-link to="/company/contact">联系我们</router-link>
      </li>
    </ul>
    <ul class="header-dropdown-s" :class="{isShow : show1}" @mouseenter="show1=true" @mouseleave="show1=flase">
      <li>
        <router-link to="/products">考试系统</router-link>
      </li>
      <li>
        <router-link to="/products/wisdom">智慧实操</router-link>
      </li>
      <li>
        <router-link to="/products/digitalize">学历提升</router-link>
      </li>
      <li>
        <router-link to="/products/agriculture">消防培训</router-link>
      </li>
      <li>
        <router-link to="/products/online">政企数字化</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      whiteback: 'rgba(254, 254, 255, 0)',
      show: false,
      show1: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (document.documentElement.scrollTop >= 100) {
        this.whiteback = 'rgba(254, 254, 255, 0.8)'
      } else {
        this.whiteback = 'rgba(254, 254, 255, 0)'
      }
    }
  },
}
</script>

<style lang='less' scoped>
* {
  margin: 0;
  padding: 0;
}

ul, li {
  margin: 0;
  padding: 0;
}

.white {
  background-color: rgba(254, 254, 255, 0.8) !important;
}

.header-container {
  width: 19.2rem;
  height: 1rem;
  font-size: 0.2rem;
  padding: 0 2.6rem;
  box-sizing: border-box;
  position: relative;
  background-color: rgba(255, 255, 255, 0);
}

.header-logo {
  float: left;
  margin-top: 0.18rem;
  width: 1rem;
  height: 1rem;
  //background-image: url('../../assets/logo/zp_logo.jpg');
  background-image: url('../../assets/logo/zpzh_logo.png');
  background-repeat: no-repeat;
  background-size: 0.8rem;
}

.header-nav {
  margin-left: 5.3rem;
}

.header-nav li {
  width: 1.72rem;
  height: 0.8rem;
  padding-top: 0.28rem;
  box-sizing: border-box;
  text-align: center;
  list-style-type: none;
  float: left;
}

.header-nav a {
  line-height: 0.29rem;
  font-weight: 400;
  color: #000000;
  text-decoration: none;

  &.active {
    box-sizing: border-box;
    padding-bottom: 0.1rem;
    border-bottom: 0.03rem solid #1E1E1E;
  }
}


//下拉菜单
.header-dropdown {
  font-size: 0.18rem;
  position: absolute;
  top: 0.8rem;
  left: 9.6rem;
  display: none;
  z-index: 99;
}

.header-dropdown li {
  width: 1.72rem;
  height: 0.6rem;
  background-color: #ffffff;
  list-style: none;
}

.header-dropdown li a {
  width: 1.72rem;
  height: 0.6rem;
  padding-top: 0.16rem;
  box-sizing: border-box;
  text-decoration: none;
  display: block;
  color: #333333;
}

.header-dropdown li a:hover {
  color: #ffffff;
  background: linear-gradient(148deg, #5EB0FD 0%, #0275EA 100%);
}

.header-dropdown-s {
  font-size: 0.18rem;
  position: absolute;
  top: 0.8rem;
  left: 11.35rem;
  display: none;
  z-index: 99;
}

.header-dropdown-s li {
  width: 1.72rem;
  height: 0.6rem;
  background-color: #ffffff;
  list-style: none;
}

.header-dropdown-s li a {
  width: 1.72rem;
  height: 0.6rem;
  padding-top: 0.16rem;
  box-sizing: border-box;
  text-decoration: none;
  display: block;
  color: #333333;
}

.header-dropdown-s li a:hover {
  color: #ffffff;
  background: linear-gradient(148deg, #5EB0FD 0%, #0275EA 100%);
}

.isShow {
  display: block;
}
</style>
